export default {"src":"/_next/static/media/right-bg.75edd962.svg","height":485,"width":245,"blurWidth":0,"blurHeight":0};